import Spinner from "react-bootstrap/Spinner";
import { CheckIcon, CloseIcon } from "../../components/icons";

/**
 * Tela de resultado do autoatendimento (pagamento TEF, status do totem e do
 * tablet): um ícone grande no tom do resultado, o título, o número do pedido
 * em destaque e as ações embaixo.
 *
 * tone: "success" | "danger" | "pending" (spinner na cor da loja)
 */
export default function TotemResult({
  tone,
  title,
  message,
  orderNumber,
  children,
  actions,
}) {
  return (
    <div className="totem-result">
      <div className={`totem-result__icon totem-result__icon--${tone}`}>
        {tone === "success" && <CheckIcon />}
        {tone === "danger" && <CloseIcon />}
        {tone === "pending" && (
          <Spinner animation="border" className="spinner-shop" />
        )}
      </div>
      <h1 className="totem-result__title">{title}</h1>
      {message && <p className="totem-result__message">{message}</p>}
      {orderNumber && (
        <div className="totem-result__number">
          <span className="totem-result__number-label">Número do pedido</span>
          <strong className="totem-result__number-value">#{orderNumber}</strong>
        </div>
      )}
      {children}
      {actions && <div className="totem-result__actions">{actions}</div>}
    </div>
  );
}
